// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementCampaignIamClickDailyStatsCampaignIdResult = objectOf({
  string: arrayOf(
    objectOf({
      tracking_id: string,
      key: string,
      total: number,
      group: string,
      group_index: number,
      rate_denominator: number,
      is_choice: boolean,
      choice_info: nullOrUndefined,
      choice_text: nullOrUndefined,
    })
  ),
});
